import React, {Component} from "react";

import "./Portal.scss";
import PageBanner from "../Components/PageBanner/PageBanner";

import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faChevronDoubleDown} from "@fortawesome/pro-light-svg-icons";

import imgBanner from "./zoon-portal.jpg";
import imgMacbookMockup from "../App/image/devices/macbook-pro-past-shoots.png";
import deviceIpadLeft from "../App/image/devices/ipad/left.png";
import deviceIpadCenterBottom from "../App/image/devices/ipad/center-bottom.png";
import deviceIpadCenterMiddle from "../App/image/devices/ipad/center-middle.png";
import deviceIpadCenterTop from "../App/image/devices/ipad/center-top.png";
import deviceIpadRight from "../App/image/devices/ipad/right.png";
import deviceImacCenterBottom from "../App/image/devices/imac/center-bottom.png";
import deviceImacCenterMiddle from "../App/image/devices/imac/center-middle.png";
import deviceImacCenterTop from "../App/image/devices/imac/center-top.png";
import deviceImacLeft from "../App/image/devices/imac/left.png";
import deviceImacRight from "../App/image/devices/imac/right.png";
import deviceIphoneCenter from "../App/image/devices/iphone/center.png";
import deviceIphoneCenterTop from "../App/image/devices/iphone/center-top.png";
import deviceIphoneLeft from "../App/image/devices/iphone/left.png";
import deviceIphoneRight from "../App/image/devices/iphone/right.png";

import theme1Desktop from "../App/image/devices/featurepage/aurora-desktop.jpg";
import theme1Ipad from "../App/image/devices/featurepage/aurora-ipad.jpg";
import theme1Iphone from "../App/image/devices/featurepage/aurora-iphone.jpg";
import theme2Desktop from "../App/image/devices/featurepage/twilight-desktop.jpg";
import theme2Ipad from "../App/image/devices/featurepage/twilight-ipad.jpg";
import theme2Iphone from "../App/image/devices/featurepage/twilight-iphone.jpg";
import theme3Desktop from "../App/image/devices/featurepage/mosaic-desktop.jpg";
import theme3Ipad from "../App/image/devices/featurepage/mosaic-ipad.jpg";
import theme3Iphone from "../App/image/devices/featurepage/mosaic-iphone.jpg";

export default class Portal extends Component {
  constructor(props) {
    super(props);
    this.state = {position: 0, theme: "twilight"};
    this.setPosition = position => this.setState({position});
  }

  componentDidMount() {
    document.title = "ZOON || Client Portal";
    document.getElementsByTagName("meta")[4].content =
      "Industry leading technology allowing for next day delivery of assets by easily sharing media with clients through the Zoon Portal";
  }

  componentWillUnmount() {}

  returnImagePosition(device, wrapper) {
    const {position} = this.state;
    let scrollPos = 0;
    if (device !== undefined) {
      scrollPos = (device.height - wrapper.height) * position * -1;
    }
    return scrollPos;
  }

  returnThemeFile = device => {
    const {theme} = this.state;
    var files = {};
    switch (theme) {
      case "mosaic":
        files = {
          desktop: theme3Desktop,
          ipad: theme3Ipad,
          iphone: theme3Iphone
        };
        break;
      case "twilight":
        files = {
          desktop: theme2Desktop,
          ipad: theme2Ipad,
          iphone: theme2Iphone
        };
        break;

      default:
        files = {
          desktop: theme1Desktop,
          ipad: theme1Ipad,
          iphone: theme1Iphone
        };
    }
    return files[device];
  };

  render() {
    const {position, theme} = this.state;
    return (
      <React.Fragment>
        <PageBanner
          bannerImg={imgBanner}
          topTitle="Easy Media Access"
          title="Client Portal"
          text="Easy access to view and download all of your shoot assets as soon as they are ready for you."
        />
        <section className=" dots-bg mb-0">
          <div className="container">
            <header className="col-12 px-0">
              <div className="title-effect" />
              <h1>
                Simplified <span>Media</span> Sharing
              </h1>
              <strong className="fade-title-left">PORTAL</strong>
            </header>
            <article className="d-flex flex-row justify-content-center service-wrap">
              <div className="col-12">
                <img src={imgMacbookMockup} alt="" className="wrap-laptop" />
                <p>
                  Zoon has developed a custom portal that is unique to the
                  industry and provides our clients with the best method of
                  obtaining your materials after every appointment. All your
                  listing materials in one easy to access online account.
                </p>
                <p>
                  After the appointment has been completed, post editing
                  provided, the materials will be posted to your shoot in the
                  portal, and we will then notify you that your assets are ready
                  to download. Upon logging into our portal to download your
                  shoot assets, you will be presented with the option to
                  download a bundle containing all shoot assets, which also
                  includes both web and print optimized versions of all your
                  photographs, as well as any PDF documents for floorplans &
                  measurements.
                </p>
                <p>
                  Your shoot media is stored in our Zoon Cloud for 1 year,
                  allowing you to easily access all of your shoot assets up to
                  365 days after the shoot completed. Once your shoot has been
                  posted for over 1 year, we send your shoot media to our
                  archival system.
                </p>
                <p>
                  Stay up to date with Zoon news, FAQ and many other great
                  benefits by logging into the Zoon Portal.
                </p>
              </div>
            </article>
          </div>
        </section>

        <section className="mb-0">
          <div className="container">
            <header className="col-12 px-0">
              <div className="title-effect" />
              <h1>
                Feature Page <span>Builder</span>
              </h1>
              <h5 className="sub-title">
                Create a custom web presence for your listing at{" "}
                <u>no extra cost</u>
              </h5>
            </header>
            <article className="d-flex flex-row justify-content-center">
              <div className="col-12">
                <p>
                  Zoon Feature Pages showcase all of your media for each listing
                  on a customizable web page. These unique, individualized
                  webpages are created through the Zoon Portal and are included
                  Free with every photography service. Create your page to suit
                  your needs, display multiple services, and add property
                  descriptions. These mini websites are hosted free of charge on
                  the Zoon cloud, providing you with one easy to share link that
                  has everything a prospective buyer wants to know.
                </p>
              </div>
            </article>
          </div>
        </section>

        <section>
          <div className="container-fluid">
            <article className="d-flex flex-row flex-wrap justify-content-center pb-0">
              <div
                className="col-12 col-md-4 offset-lg-2 px-0 order-2 order-md-1"
                id="device-mockups-wrapper"
              >
                <div className="offset-ipad">
                  <div className="device-mockup">
                    <div className="side-wrap" style={{left: 0}}>
                      <img src={deviceIpadLeft} alt="" className="left" />
                    </div>
                    <div className="middle-wrapper">
                      <img src={deviceIpadCenterTop} alt="" className="" />
                      <div className="screen-wrapper">
                        <img
                          src={deviceIpadCenterMiddle}
                          alt=""
                          className="device-overlay"
                          ref={ref => {
                            this.tabletWrap = ref;
                          }}
                        />
                        <img
                          className="screen-media"
                          alt=""
                          src={this.returnThemeFile("ipad")}
                          // src={`../images/portal/featurepage/${theme}-ipad.jpg`}
                          id="macFrame"
                          ref={ref => {
                            this.tabletFrame = ref;
                          }}
                          style={{
                            top: this.returnImagePosition(
                              this.tabletFrame,
                              this.tabletWrap
                            )
                          }}
                        />
                      </div>
                      <img src={deviceIpadCenterBottom} alt="" className="" />
                    </div>
                    <div className="side-wrap" style={{right: 0}}>
                      <img src={deviceIpadRight} alt="" className="right" />
                    </div>
                  </div>
                </div>
                <div className="device-mockup">
                  <div className="side-wrap" style={{left: 0}}>
                    <img src={deviceImacLeft} alt="" className="left" />
                  </div>
                  <div className="middle-wrapper">
                    <img src={deviceImacCenterTop} alt="" className="" />
                    <div className="screen-wrapper">
                      <img
                        src={deviceImacCenterMiddle}
                        alt=""
                        className="device-overlay"
                        ref={ref => {
                          this.macWrap = ref;
                        }}
                      />
                      <img
                        className="screen-media"
                        alt=""
                        src={this.returnThemeFile("desktop")}
                        id="macFrame"
                        ref={ref => {
                          this.macFrame = ref;
                        }}
                        style={{
                          top: this.returnImagePosition(
                            this.macFrame,
                            this.macWrap
                          )
                        }}
                      />
                    </div>
                    <img src={deviceImacCenterBottom} alt="" className="" />
                  </div>
                  <div className="side-wrap" style={{right: 0}}>
                    <img src={deviceImacRight} alt="" className="right" />
                  </div>
                </div>

                <div className="offset-iphone">
                  <div className="device-mockup">
                    <div className="side-wrap" style={{left: 0}}>
                      <img src={deviceIphoneLeft} alt="" className="left" />
                    </div>
                    <div className="middle-wrapper">
                      <img src={deviceIphoneCenterTop} alt="" className="" />
                      <div className="screen-wrapper">
                        <img
                          src={deviceIphoneCenter}
                          alt=""
                          className="device-overlay"
                          ref={ref => {
                            this.phoneWrap = ref;
                          }}
                        />
                        <img
                          className="screen-media"
                          alt=""
                          src={this.returnThemeFile("iphone")}
                          id="macFrame"
                          ref={ref => {
                            this.phoneFrame = ref;
                          }}
                          style={{
                            top: this.returnImagePosition(
                              this.phoneFrame,
                              this.phoneWrap
                            )
                          }}
                        />
                      </div>
                    </div>
                    <div className="side-wrap" style={{right: 0}}>
                      <img src={deviceIphoneRight} alt="" className="right" />
                    </div>
                  </div>
                </div>
              </div>

              <div className="col-12 col-md-2 order-1 order-md-2">
                <div
                  className="btn-group d-flex"
                  id="theme-btn-group"
                  role="group"
                >
                  <button
                    type="button"
                    className={`btn ${theme === "aurora" ? "active" : ""}`}
                    onClick={() => this.setState({theme: "aurora"})}
                  >
                    Aurora
                  </button>
                  <button
                    type="button"
                    className={`btn ${theme === "twilight" ? "active" : ""}`}
                    onClick={() => this.setState({theme: "twilight"})}
                  >
                    Twilight
                  </button>
                  <button
                    type="button"
                    className={`btn ${theme === "mosaic" ? "active" : ""}`}
                    onClick={() => this.setState({theme: "mosaic"})}
                  >
                    Mosaic
                  </button>
                </div>
                <div className="form-group portal-slider">
                  <div className="range-wrap">
                    {position === 0 ? (
                      <div className="scroll">
                        <span>Select theme &amp; scroll to view layout</span>
                        <FontAwesomeIcon icon={faChevronDoubleDown} />
                      </div>
                    ) : null}
                    <input
                      type="range"
                      value={position}
                      name="position"
                      onChange={e => this.setPosition(e.target.valueAsNumber)}
                      min="0"
                      max="1"
                      step="0.001"
                      className="position-range vertical"
                    />
                  </div>
                </div>
              </div>
            </article>
          </div>
        </section>
      </React.Fragment>
    );
  }
}
